import './Sidebar.css'

function Sidebar({ currentView, onViewChange }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h1>Olivea</h1>
      </div>

      <div className="sidebar-content">
        <a href="mailto:hello@meetolive.io" className="raise-issue-btn">
          <span className="plus-icon">+</span>
          Raise an Issue
        </a>

        <ul className="nav-list">
          <li className="nav-item">
            <a 
              className={`nav-link ${currentView === 'overview' ? 'active' : ''}`}
              onClick={() => onViewChange('overview')}
            >
              <span className="nav-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="2" fill="none"/>
                </svg>
              </span>
              Overview
            </a>
          </li>
          <li className="nav-item">
            <a 
              className={`nav-link ${currentView === 'heatmap' ? 'active' : ''}`}
              onClick={() => onViewChange('heatmap')}
            >
              <span className="nav-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7v10c0 5.5 3.8 9.7 10 11 6.2-1.3 10-5.5 10-11V7l-10-5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" fill="none"/>
                  <circle cx="12" cy="12" r="3" fill="currentColor"/>
                </svg>
              </span>
              Escalations
            </a>
          </li>
          <li className="nav-item">
            <a 
              className={`nav-link ${currentView === 'analytics' ? 'active' : ''}`}
              onClick={() => onViewChange('analytics')}
            >
              <span className="nav-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 3v16a2 2 0 002 2h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M7 16l4-8 4 4 4-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              Analytics
            </a>
          </li>
          <li className="nav-item">
            <a 
              className={`nav-link ${currentView === 'archive' ? 'active' : ''}`}
              onClick={() => onViewChange('archive')}
            >
              <span className="nav-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 8h18M3 8v11a2 2 0 002 2h14a2 2 0 002-2V8M3 8l2-5h14l2 5M10 12h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              Archive
            </a>
          </li>
          <li className="nav-item">
            <a 
              className={`nav-link ${currentView === 'efficiencies' ? 'active' : ''}`}
              onClick={() => onViewChange('efficiencies')}
            >
              <span className="nav-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" fill="none"/>
                </svg>
              </span>
              Efficiencies
            </a>
          </li>
        </ul>
      </div>
    </aside>
  )
}

export default Sidebar

